module.exports = __webpack_public_path__ + "890113d0f2431b00e963e884c77ce175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover.jpg
// module id = 259
// module chunks = 1